import React, { useState, useRef, useMemo, useEffect } from 'react';
import JoditEditor from 'jodit-react';
import Swal from 'sweetalert2';
import {
  Button,
  // DatePicker,
  Form,
  Input,
} from 'antd';
import { Modal } from 'react-bootstrap';
import { useAdminClient } from "hooks/useAdminClient";

const EditArticle = (params) => {
  const client = useAdminClient();
  const {placeholder, data} = params;
	const editor = useRef(null);
	const [content, setContent] = useState();
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [form] = Form.useForm();
  const formItemLayout = {
    labelCol: {
      xs: {
        span: 24,
      },
      sm: {
        span: 6,
      },
    },
    wrapperCol: {
      xs: {
        span: 24,
      },
      sm: {
        span: 14,
      },
    },
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    setFile(selectedFile);
    setPreview(URL.createObjectURL(selectedFile));
  };

  useEffect(() => {
    // setPreview(data.img)
    form.resetFields()
    setContent(data.text)
  }, [data])

	const config = useMemo(() => ({
			readonly: false, // all options from https://xdsoft.net/jodit/docs/,
			placeholder: placeholder || 'Start typings...',
		}),
		[placeholder]
	);

  const handleSubmit = async (e) => {
    try {
      const formData = new FormData();
      const {
        InputPostCreator,
        InputPostTitle,
        InputPostCardTitle,
        InputPostCardTextDetail,
        InputPostTextDetail,
      } = e;
      
      formData.append("img", file);
      formData.append("title", InputPostTitle);
      formData.append("text", InputPostTextDetail);
      formData.append("card_title", InputPostCardTitle);
      formData.append("card_text", InputPostCardTextDetail);
      formData.append("creator", InputPostCreator);
      
      await client.put(`/be/api/v1/articles/edit/${data.id}`, formData, { headers: { "Content-Type": "multipart/form-data", 
        "Authorization": `Bearer ${localStorage.getItem("authToken")}`, // Add Bearer prefix
      }});
      Swal.fire({
        position: "top-end",
        icon: "success",
        title: "Edit article success",
        showConfirmButton: false,
        timer: 1500
      });
      params.setShowModal(false);
      params.fetchData();
    } catch (error) {
      console.log(error);
      Swal.fire({
        position: "top-end",
        icon: "error",
        title: "Edit articles error",
        showConfirmButton: false,
        timer: 1500
      });
    }
  }

	return (
    <div id='edit-article'>
      <Modal
        show={params.showModal}
        onHide={params.handleClose}
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-custom-modal-styling-title">
            Edit Article
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form
            {...formItemLayout}
            form={form}
            onFinish={handleSubmit}
          >
            <Form.Item
              label="Input Banner Image"
              name="InputBannerImg"
              rules={[
                {
                  // required: true,
                  message: 'Please input!',
                },
              ]}
            >
              <Input type="file" accept="image/*" onChange={handleFileChange}/>
              {preview && <img src={preview} alt="Preview" width="200" />}
            </Form.Item>
            <Form.Item
              label="Input Post Creator"
              name="InputPostCreator"
              initialValue={data.creator}
              rules={[
                {
                  required: true,
                  message: 'Please input!',
                },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              label="Input Post Title"
              name="InputPostTitle"
              initialValue={data.title}
              rules={[
                {
                  required: true,
                  message: 'Please input!',
                },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              label="Input Post Card Title"
              name="InputPostCardTitle"
              initialValue={data.card_title}
              rules={[
                {
                  required: true,
                  message: 'Please input!',
                },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              label="Input Post Card Text Detail"
              name="InputPostCardTextDetail"
              initialValue={data.card_text}
              rules={[
                {
                  required: true,
                  message: 'Please input!',
                },
              ]}
            >
              <Input
                style={{
                  width: '100%',
                }}
              />
            </Form.Item>

            <Form.Item
              label="Input Post Text Detail"
              name="InputPostTextDetail"
              initialValue={data.text}
              rules={[
                {
                  required: true,
                  message: 'Please input!',
                },
              ]}
            >
              <JoditEditor
                ref={editor}
                value={content}
                config={config}
                tabIndex={1} // tabIndex of textarea
                onBlur={newContent => setContent(newContent)} // preferred to use only this option to update the content for performance reasons
                onChange={newContent => {}}
              />
            </Form.Item>

            {/* <Form.Item
              label="Post Date"
              name="PostDate"
              initialValue={moment(data.date)}
              // style={{zIndex: 1000}}
              rules={[
                {
                  required: true,
                  message: 'Please input!',
                },
              ]}
            >
              <DatePicker />
            </Form.Item> */}

            <Form.Item
              wrapperCol={{
                offset: 6,
                span: 16,
              }}
            >
              <Button
                style={{maxWidth: "100px"}}
                type="primary"
                htmlType="submit"
              >
                Submit
              </Button>
            </Form.Item>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
	);
};

export default EditArticle